import { Col, Image, Row, Typography } from 'antd';
import dmcaImage from '../../assets/dmcaproteted.png';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { styles } from '../../styles';
import logo from '../../assets/logo/logo.webp';
// import { LOGO_URL } from '../../utils/constant';

export default function FooterComponent() {
  return (
    <>
    <Row gutter={24} style={{...styles.flexDisplay, marginBottom: '10px'}}>
        <Col span={16}>
            <Row gutter={24} style={styles.flexDisplay}>
                <Image width={80} src={dmcaImage} alt='dmca'/>
            </Row>
            <Row gutter={24}>
                <Typography.Text style={{color: '#fff'}}>
                Disclaimer: This website does not host any of the videos referenced herein. Links to streams from external platforms such as YouTube are provided solely for user convenience. The website disclaims any responsibility for the legality of the content. All legal inquiries or issues should be addressed directly to the respective media file owners or hosting platforms.
                </Typography.Text>
            </Row>
        </Col>
    </Row>
    <Row gutter={24} style={styles.flexDisplay}>
        <Col span={4}>
            {/* <Image width={150} src={LOGO_URL} alt='koostream-logo'/> */}
            <img src={logo} className='logo-img' alt='website-logo' />
        </Col>
        <Col span={4}>
            <Link to={'/about'} >
                <Typography.Text style={{color: '#fff'}}>About Us</Typography.Text>
            </Link>
        </Col>
        <Col span={4}>
            <Link to={'/privacy-policy'} >
                <Typography.Text style={{color: '#fff'}}>Privacy Policy</Typography.Text>
            </Link>
        </Col>
        <Col span={4}>
            <Link to={'/contact-us'} >
                <Typography.Text style={{color: '#fff'}}>Contact Us</Typography.Text>
            </Link>
        </Col>
        <Col span={8}>
            <Typography.Text style={{color: '#fff'}}>Copyright © {dayjs(new Date()).format('YYYY')} Koostream All rights reserved.</Typography.Text>
        </Col>
    </Row>
    </>
  );
}
